/* eslint-disable jsx-a11y/label-has-associated-control */
import React  from 'react';     
import { InputTextarea } from 'primereact/inputtextarea';

const FieldTextArea =  (props) => {
    
    const onChange = (value) => {  
        if (props.onChange !== undefined){
            props.onChange(value);
        } 
    }  

    const onClick = () => {  
      if (props.onClick !== undefined){
          props.onClick();
      } 
    }  

    const isFormFieldInValid = (name) => !!(typeof(props.errors) !== 'undefined' && props.errors !== null && props.errors[name]);
    
    const getFormErrorMessage = (name) => { 
        return isFormFieldInValid(name) && <small className="p-error">{props.errors[name].message}</small>;
    };

    const onFocus = (event) => {
      event.target.select();
      if (props.onFocus !== null && typeof(props.onFocus) === 'function'){
        props.onFocus(event);
      } 
    }

    return (  
      <>  
        <span className="p-float-label">
          <InputTextarea
            rows={props.rows}
            value={props.value === null ? '' : props.value}
            onChange={onChange} 
            onClick={onClick} 
            placeholder={props.placeholder}
            className={` ${props.className === undefined ? '' : props.className} ${isFormFieldInValid(props.name) === true ? 'p-invalid' : ''} `}
            maxLength={props.maxLength}
            disabled={props.disabled}
            style={props.style? {...{resize: 'none'}, ...props.style} : {resize: 'none'}}
            readOnly={props.readonly}
            onFocus={onFocus}
            autoFocus={props.autoFocus}
            autoResize={props.autoResize? props.autoResize : false}
            onKeyDown={props.onKeyDown}
          />
          { /* <small>{props.value===null?0:props.value.length}/{props.maxLength}</small> */ }
          <label className={isFormFieldInValid(props.name) === true ? 'p-error' : ''}>{props.label}</label>
        </span>
        { getFormErrorMessage(props.name) } 
      </> 
    )
}   

    
export default FieldTextArea; 
